const retryRequest = async (requestFn, maxRetries = 2) => {
  for (let i = 0; i <= maxRetries; i++) {
    try {
      return await requestFn();
    } catch (error) {
      if (i === maxRetries) throw error;

      // Exponential backoff: 1s, 2s, 4s
      const delay = 1000 * Math.pow(2, i);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
};

export const apiHandler = async (requestFn, options = {}) => {
  const {
    retries = 0,
    defaultValue = null,
    suppressErrors = false,
    showNotification = true
  } = options;

  try {
    let result;

    if (retries > 0) {
      result = await retryRequest(requestFn, retries);
    } else {
      result = await requestFn();
    }

    return result.data || result;
  } catch (error) {
    if (!suppressErrors) {
      console.error('Request failed:', error.message);

      if (showNotification && window.showNotification) {
        window.showNotification(error.message, 'error');
      }
    }

    if (defaultValue !== null) {
      return defaultValue;
    }

    throw error;
  }
};